import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { motion } from "framer-motion";

type MembershipNavLinkProps = {
  icon: React.ReactNode;
  label: string;
  active?: boolean;
  onClick: () => void;
};

const MembershipNavLink: React.FC<MembershipNavLinkProps> = ({
  icon,
  label,
  active = false,
  onClick
}) => (
  <motion.div whileHover={{ y: -1 }} whileTap={{ scale: 0.97 }}>
    <Button
      onClick={onClick}
      disableElevation
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        px: { xs: 1.25, sm: 1.75 },
        py: { xs: 0.625, sm: 0.75 },
        minWidth: 0,
        borderRadius: 2.5,
        textTransform: "none",
        fontWeight: 600,
        letterSpacing: "-0.01em",
        color: "primary.main",
        border: "1px solid",
        borderColor: active ? alpha("#6f49c9", 0.35) : alpha("#6f49c9", 0.14),
        background: active
          ? `linear-gradient(135deg, ${alpha("#6f49c9", 0.16)} 0%, ${alpha("#667eea", 0.22)} 100%)`
          : alpha("#fff", 0.72),
        boxShadow: active
          ? `0 4px 16px ${alpha("#6f49c9", 0.2)}`
          : `0 1px 4px ${alpha("#6f49c9", 0.06)}`,
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        transition:
          "background 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease",
        "&:hover": {
          background: `linear-gradient(135deg, ${alpha("#6f49c9", 0.12)} 0%, ${alpha("#667eea", 0.18)} 100%)`,
          borderColor: alpha("#6f49c9", 0.32),
          boxShadow: `0 6px 20px ${alpha("#6f49c9", 0.16)}`
        }
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: { xs: 28, sm: 30 },
          height: { xs: 28, sm: 30 },
          borderRadius: "50%",
          flexShrink: 0,
          color: "primary.main",
          background: active
            ? `linear-gradient(145deg, ${alpha("#6f49c9", 0.22)} 0%, ${alpha("#667eea", 0.28)} 100%)`
            : alpha("#6f49c9", 0.1),
          boxShadow: active ? `inset 0 1px 0 ${alpha("#fff", 0.45)}` : "none",
          transition: "background 0.25s ease"
        }}
        aria-hidden
      >
        {icon}
      </Box>
      <Typography
        component="span"
        sx={{
          fontWeight: 600,
          fontSize: { xs: "0.8125rem", sm: "0.875rem" },
          lineHeight: 1.2,
          color: "primary.main"
        }}
      >
        {label}
      </Typography>
    </Button>
  </motion.div>
);

export default MembershipNavLink;
